'use client'

import {DependencyList} from 'react'
import useWindowEvent, {WindowEvent} from './useWindowEvent'

const useWindowResize = (
	cb: (e: WindowEvent) => void,
	triggerInit:boolean = false,
	useEffectProps:DependencyList = [],
	debounceDelay:number = 40,
) => useWindowEvent('resize', cb, triggerInit, useEffectProps, debounceDelay)

export default useWindowResize
